const constanciasRoutes = [
  {
    path: '/constancias',
    name: 'constancias',
    component: () => import('./views/index.vue'),
  },
];

export default constanciasRoutes;